import { requestHandler } from 'shared/utils';
import { IBaseResponseModel } from 'types/general';

const BASE_URL = '/v1/campaigns';

export const JoinCampaign = (campaignName: TCampaignName) => {
	return requestHandler
		.call<IBaseResponseModel<boolean>>({ url: `${BASE_URL}/${campaignName}/join`, method: 'post' })
		.then(x => x.result);
};

export const GetUserCampaignStats = (campaignName: TCampaignName) => {
	return requestHandler
		.call<IBaseResponseModel<ICampaignStats>>({ url: `${BASE_URL}/${campaignName}/stats`, method: 'get' })
		.then(x => x.result);
};

export const GetCampaignInfo = (campaign: TCampaignName) => {
	return requestHandler.call<IBaseResponseModel<ICampaign>>({ url: `${BASE_URL}/${campaign}`, method: 'get' }).then(x => x.result);
};
